<div class="user-list">
    <div *ngIf="showSpinner" class="progress-spinner">
        <mat-spinner></mat-spinner>
    </div>
    <div class="intro">
        <h2 class="mat-display-2">List of the users</h2>
        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Voluptate quaerat repudiandae, quis aspernatur voluptatibus deleniti eveniet voluptatem, nihil odio alias neque beatae quae. Nihil esse, rerum accusamus eveniet praesentium eos vel libero iste, nemo dolorem odit hic ipsa obcaecati quod, aliquam optio animi ut atque error placeat quam? Harum, corporis!</p>
    </div>
    <div class="list">
        <div class="mat-display-1">
            <mat-icon>list</mat-icon><br>
            Users list
        </div>
    
        <mat-form-field>
            <input (keyup)="applyFilter($event)" matInput placeholder="Filter">
        </mat-form-field>
    
        <div class="mat-elevation-z8">
            <table mat-table [dataSource]="dataSource" matSort>
        
                <!-- Position Column -->
                <ng-container matColumnDef="position">
                  <th mat-header-cell *matHeaderCellDef> No. </th>
                  <td mat-cell *matCellDef="let i = index"> {{this.paginator.pageIndex == 0 ? i + 1 : 1 + i + this.paginator.pageIndex * this.paginator.pageSize}} </td>
                </ng-container>
              
                <!-- Email Column -->
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
                  <td mat-cell *matCellDef="let user"> 
                    <a routerLink="{{user.username}}">{{user.email}}</a> </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                  <td mat-cell *matCellDef="let user"> 
                    <a routerLink="{{user.username}}">{{user.name}}</a> </td>
                </ng-container>
              
                <!-- Username Column -->
                <ng-container matColumnDef="username">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Username </th>
                  <td mat-cell *matCellDef="let user"> 
                    <a routerLink="{{user.username}}">{{user.username}}</a> </td>
                </ng-container>
                
                <!-- Roles Column -->
                <ng-container matColumnDef="roles">
                  <th mat-header-cell *matHeaderCellDef> Roles </th>
                  <td mat-cell *matCellDef="let user">
                    <span *ngFor="let role of user.roles"> {{ role.name }} </span>
                  </td>
                </ng-container>
    
                <!-- Created at Column -->
                <ng-container matColumnDef="created_at">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Created at </th>
                  <td mat-cell *matCellDef="let user"> 
                    <a routerLink="{{user.username}}">{{user.created_at | date: 'MM/dd/yyyy'}}</a> </td>
                </ng-container>
    
                <!-- Updated at Column -->
                <ng-container matColumnDef="edited_at">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Edited at </th>
                  <td mat-cell *matCellDef="let user"> 
                    <a routerLink="{{user.username}}">{{user.edited_at | date: 'MM/dd/yyyy'}}</a> </td>
                </ng-container>
        
                <!-- Edit Column -->
                <ng-container matColumnDef="edit">
                  <th mat-header-cell *matHeaderCellDef> Edit </th>
                  <td mat-cell *matCellDef="let user">
                    <button mat-icon-button routerLink="{{user.username}}/edit">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </td>
                </ng-container>
        
                <!-- Delete Column -->
                <ng-container matColumnDef="delete">
                  <th mat-header-cell *matHeaderCellDef> Delete </th>
                  <td mat-cell *matCellDef="let user">
                    <button mat-icon-button>
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>
              
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </div>
</div>